import React, { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import LoginModal from "../common/LoginModal/LoginModal";
import Sidebar from "../components/Sidebar/Sidebar";
import usePageBottom from "../hooks/usePageBottom";
import AuthContext from "../store/auth-context";
import BaseLayoutProvider from "../store/BaseLayoutContext";

const BaseLayout = () => {
  const authContext = useContext(AuthContext);
  const customElementRef = useRef(null);
  const reachedBottom = usePageBottom(
    { rootMargin: 0, threshold: 0.5 },
    customElementRef
  );
  const location = useLocation();
  const isForgotPasswordPage = location.pathname.includes(
    "/users/update-password/"
  );
  const isPublicPage =
    location.pathname.includes("/users/update-password") ||
    location.pathname.includes("/");
  const shouldShowSidebar = authContext.isLoggedIn || !isPublicPage;
  const navigate = useNavigate();
  const [hasCheckedRedirect, setHasCheckedRedirect] = useState(false);
  const [signOrSignUp, setSignOrSignUp] = useState(true);
  const [triggerLoginModuleToggleValue, setTriggerLoginModuleToggleValue] = useState(false);

  const TriggerLoginModuleBtn = () => {
    setTriggerLoginModuleToggleValue(true);
  };

  const chooseSignUp_SignIn = (bool) => {
    setSignOrSignUp(bool);
  };

  useEffect(() => {
    authContext.hasDiscoveryReachedBottomHandler(reachedBottom);
  }, [reachedBottom]);

  useEffect(() => {
    const storedRedirect = localStorage.getItem("redirectAfterLogin");
    if (authContext.isLoggedIn && storedRedirect) {
      localStorage.removeItem("redirectAfterLogin");
      navigate(storedRedirect);
    } else if (!authContext.isLoggedIn && storedRedirect) {
      chooseSignUp_SignIn(true);
      TriggerLoginModuleBtn();
    }
    setHasCheckedRedirect(true);
  }, [authContext.isLoggedIn, navigate]);

  return (
    <BaseLayoutProvider>
      <React.Fragment>
        {!isForgotPasswordPage && (
          <div className="fixed top-0 w-full z-10">
            <Navbar />
          </div>
        )}
        <div className="overflow-y-hidden">
          {shouldShowSidebar && (
            <aside
              className="fixed top-[5.1rem] left-0 w-fit h-screen z-10"
              aria-label="Sidebar"
            >
              <div className="h-full overflow-y-auto">
                <Sidebar />
              </div>
            </aside>
          )}

          <div
            className={`${
              shouldShowSidebar ? "ml-[5.7rem]" : "ml-0"
            } ${isForgotPasswordPage ? "mt-0" : "mt-[5.1rem]"} overflow-auto`}
          >
            <Outlet />
          </div>
          {/* <Outlet /> */}
        </div>
        <LoginModal />
      </React.Fragment>
    </BaseLayoutProvider>
  );
};

export default BaseLayout;
